import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";

// Guards the books admin portal — entirely separate from multi-iq's own
// /admin (different Supabase project, different credentials).
export default function AdminRoute({ children }) {
  const { user, loading, isConfigured } = useAdminAuth();
  const location = useLocation();

  if (!isConfigured) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white p-4">
        <p className="text-zinc-500">Books Supabase not configured.</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <p className="text-zinc-500">Loading…</p>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate to="/admin/books-portal/login" state={{ from: location }} replace />
    );
  }

  return children;
}
